export default {
  // 表單標籤
  address: "地址:",
  blockchain: "所屬鏈:",
  currency: "幣種:",
  monitorCondition: "監控條件:",
  monitorDirection: "監控方向",
  monitorName: "監控名稱:",
  relatedCase: "關聯案件(選填)",
  remark: "備註",
  monitorType: "監控類型:",
  pushChannel: "推送渠道:",

  // 佔位符
  inputAddress: "請輸入地址",
  selectBlockchain: "請選擇主鏈",
  selectCurrency: "請選擇幣種",
  minAmount: "最小金額",
  maxAmount: "最大金額",
  inputMonitorName: "請輸入監控名稱",
  selectRelatedCase: "請選擇關聯案件",
  inputRemark: "請輸入備註內容",
  pleaseSelect: "請選擇",

  // 監控方向
  bidirectional: "雙向",
  inflow: "流入",
  outflow: "流出",

  // 監控類型
  commonMonitor: "普通監控（交易信息實時更新，無推送功能）",
  realtimeMonitor: "實時監控（交易信息實時更新和推送，可選擇下方推送渠道）",

  // 推送渠道
  dingtalk: "釘釘",
  email: "郵箱",
  wechat: "微信",
  dingtalkHelp: "如何獲取釘釘群機器人簽名密鑰和Webhook地址？",
  inputDingtalkSecret: "請輸入釘釘群機器人簽名密鑰",
  inputDingtalkWebhook: "請輸入釘釘機器人Webhook地址",
  inputDingtalkPhone: "請輸入釘釘手機號(非必填,釘釘群推送可艾特到指定人)",
  inputEmail: "請輸入郵箱地址",

  // 微信綁定
  bound: "已綁定",
  toBind: "待綁定，",
  clickToBind: "點擊掃碼綁定微信",

  // 按鈕
  return: "返回",
  confirm: "確認",

  // 對話框
  dialogTitle: "釘釘添加機器人操作說明",

  // 提示信息
  maxAmountTip: "最大金額需≥最小金額",
  maxValueTip: "最大值要比最小值大",
  pleaseBindWechat: "請先綁定微信",
  pleaseSelectChannel: "請選擇渠道",
  addMonitorSuccess: "添加監控成功",

  // 表單驗證
  inputMonitorNameRequired: "請輸入監控名稱",
  monitorNameLength: "長度在 1 到 20 個字符",
  selectBlockchainRequired: "請選擇主鏈",
  inputAddressRequired: "請輸入地址",
  minAmountRequired: "最小金額不能為空",
  maxAmountRequired: "最大金額不能為空",
  selectMonitorDirection: "請選擇監控方向",
  inputRemarkContent: "請填寫備註內容",
  selectMonitorType: "請選擇監控類型",
  inputCorrectEmail: "請輸入正確的郵箱地址",
  inputCorrectPhone: "請輸入正確的手機號碼",
  inputValidPhone: "請輸入合法手機號/電話號",
  inputDingtalkSecretRequired: "請輸入釘釘群機器人簽名密鑰",
  inputDingtalkWebhookRequired: "請輸入釘釘地址",
};
